import { SearchResultSet, SubstrateSearchResponse } from '../schema/SubstrateSearchResponse';

/**
 * Helper function which extracts ResultSet from 3S response
 */
export const getSearchResultSet = (response: SubstrateSearchResponse): SearchResultSet =>
    response?.EntitySets?.[0]?.ResultSets?.[0];
